import React, {Component} from 'react';

import Layout from '../components/Layout/Layout';
import IssuanceBlock from "../components/IssuanceBlock/IssuanceBlock";
import axios from "axios";
import {bindActionCreators} from "redux";
import {
  setCustomerData,
  setGameleadDiscount,
  setGameleadPresent,
  setWidgetDiscount,
  setWidgetPresent,
  setOrderCode,
  setProlongation,
  setPromocode,
  setResultCard,
  setStudentStatus,
  switchInstallmentDiscount,
  switchMilleniumClub
} from "../actions/card";
import {connect} from "react-redux";

class OrderScreen extends Component {

  componentDidMount() {
    if (!this.props.match.params.code) {
      this.props.history.push('/')
    }

    const self = this

    if (!this.props.resultCard) {
      axios.get(`${process.env.REACT_APP_API_SITE}/order/${self.props.match.params.code}`)
        .then(response => {
          if (!response.data.success || !response.data.data.hasOwnProperty('resultCard') || !response.data.data.hasOwnProperty('customerData')) {
            self.props.history.push('/')
          }

          const data = response.data.data

          let customerData = data.customerData
          if (customerData.activationDate) {
            customerData.activationDate = new Date(customerData.activationDate)
          }

          self.props.setOrderCode(self.props.match.params.code)
          self.props.setResultCard(data.resultCard)
          self.props.setProlongation(data.prolongation, data.prolongationDiscount);
          self.props.setGameleadDiscount(data.resultCard.gamelead && data.resultCard.gamelead_type == 'discount' ? data.gameleadDiscount : 0)
          self.props.setGameleadPresent(data.resultCard.gamelead && data.resultCard.gamelead_type == 'present' ? data.gameleadPresent : '')
          self.props.setWidgetDiscount(data.resultCard.apply_widget_discount && data.widgetDiscount ? data.widgetDiscount : 0)
          self.props.setWidgetPresent(data.resultCard.apply_widget_discount && data.widgetPresent ? data.widgetPresent : '')
          if (self.props.promocode) {
            self.props.setPromocode(data.promocode)
          }
          self.props.switchInstallmentDiscount(data.installmentDiscount)
          self.props.setStudentStatus(data.studentStatus)
          self.props.switchMilleniumClub(data.milleniumAdded)
          self.props.setCustomerData(customerData)
        }).catch(function (error) {
          self.props.history.push('/')
        })
    }
  }

  render() {
    return(
      <Layout page="main">
        {this.props.resultCard && <IssuanceBlock history={this.props.history} />}
      </Layout>
    )
  }
}

function mapStateToProps(state) {
  return {
    resultCard: state.card.resultCard,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  setCustomerData,
  setProlongation,
  setGameleadDiscount,
  setGameleadPresent,
  setWidgetDiscount,
  setWidgetPresent,
  setPromocode,
  switchMilleniumClub,
  setResultCard,
  setStudentStatus,
  switchInstallmentDiscount,
  setOrderCode
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OrderScreen);